/**
 * Maps a prescription_catalog `internal_drug_id` to a brand-level display name
 * suitable for patient-facing headers (e.g. "Zepbound® KwikPen").
 *
 * Mapping (by internal_drug_id prefix):
 *  - `zepbound_kwikpen_*` → "Zepbound® KwikPen"
 *  - `zepbound_vial_*`    → "Zepbound® Single-Dose Vial"
 *  - `wegovy_oral_*`      → "Wegovy® Pill"
 *  - `wegovy_*`           → "Wegovy® Pen"
 *  - `foundayo_*`         → "Foundayo®"
 *
 * Returns `null` when no mapping is known.
 */
export const getBrandDisplayName = (
  internalDrugId: string | null | undefined
): string | null => {
  if (!internalDrugId) return null;
  const id = internalDrugId.toLowerCase();
  if (id.startsWith("zepbound_kwikpen")) return "Zepbound® KwikPen";
  if (id.startsWith("zepbound_vial")) return "Zepbound® Single-Dose Vial";
  if (id.startsWith("wegovy_oral")) return "Wegovy® Pill";
  if (id.startsWith("wegovy_")) return "Wegovy® Pen";
  if (id.startsWith("foundayo")) return "Foundayo®";
  return null;
};
